import { camelize } from 'humps';

export const camelizeObject = <T extends Record<string, unknown>>(data: T) =>
    Object.entries(data).reduce(
        (acc, [key, value]) => ({ ...acc, [camelize(key)]: value }),
        {},
    );
